var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('resident-list-filter'),_vm._v(" "),(_vm.show == 'current')?_c('resident-list',{attrs:{"property":"property"}}):_vm._e(),_vm._v(" "),(_vm.show == 'past')?_c('past-resident-list'):_vm._e(),_vm._v(" "),(_vm.show == 'report')?_c('resident-reports'):_vm._e(),_vm._v(" "),_c('update-resident'),_vm._v(" "),_c('add-resident')],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c588ded","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/person/residents/ResidentListDashboard.vue
// module id = HndY
// module chunks = 0 1